<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      经营范围： 文化艺术交流策划；企业形象策划；设计、制作、发布、代理各类广告；<br>
      礼仪服务；展览展示服务；会务服务；计算机软件开发；<br>
      从事计算机软件科技领域内的技术开发、技术服务、技术咨询、技术转让。
    </p>
    <div class="bottom">Copyright © 2022 上海乐狮文化传播有限公司 <a href="https://beian.miit.gov.cn/">沪ICP备17024901号-1</a></div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.bottom {
  bottom: 20px;
  position: absolute;
  text-align: center;
  width: 100%;
}
</style>
